'use client';

import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import Twin from './twin';
import styles from './chat-widget.module.css';

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <div className={styles.widget}>
      <div
        className={`${styles.panel} ${!isOpen ? styles.panelHidden : ''}`}
        role="dialog"
        aria-modal="false"
        aria-label="Christopher chat window"
        aria-hidden={!isOpen}
      >
        <div className={styles.panelBody}>
          <Twin
            onMinimize={() => setIsOpen(false)}
            onClose={() => setIsOpen(false)}
          />
        </div>
      </div>

      <button
        type="button"
        onClick={toggle}
        className={styles.launcher}
        aria-label={isOpen ? 'Hide chat' : 'Open chat'}
      >
        <MessageCircle className={styles.launcherIcon} />
      </button>
    </div>
  );
}
